import React, { Component } from 'react';
import { connect } from 'react-redux';
import { LinearProgress } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { showError } from '../../actions/uiActions';
import FormsApi from '../../api/forms';
import { getFileTypeByExtension } from '../../utils/Validators';
import { CloudDownload, DocumentScanner } from '@mui/icons-material';
import { extractFileLastName } from '../../utils/Formatter';

class PreviewProofFile extends Component {
  state = {
    loading: true,
    fileName: '',
    content: '',
    selectFormPosition: null
  }

  componentDidMount() {
    this.getDocument()
  }

  getDocument = async () => {
    this.setState({ loading: true });
    let response = null
    try {
      response = await FormsApi.getMMPProofFile(this.props.loanProof);
    } catch (error) {
      this.props.showError('An error occurred while fetching form');
    } finally {
      if (response && response.data) {
        const mimeType = getFileTypeByExtension(this.props.loanProof)
        const blob = new window.Blob([response.data], { type: mimeType });
        this.setState({
          fileName: response.file.split(".")[0].replace(/_/g, " "),
          content: URL.createObjectURL(blob),
        })
      }
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        open={true}
        maxWidth="xl"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">Proof</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className="text-center"
          >
            {this.state.loading && <LinearProgress />}
            <div className='flex justify-content-center'>
              {!this.state.loading && (
                <div className="dynamic-form-wrapper" style={{ width: '1150px' }}>
                  <embed src={this.state.content} className="dynamic-form-container" />
                </div>
              )}
            </div>
          </DialogContentText>
        </DialogContent>
        {!this.state.loading && (
          <DialogActions>
            <Button onClick={this.props.onClose}>Close</Button>
          </DialogActions>
        )}
      </Dialog>
    )
  }
}

export default connect(null, { showError })(PreviewProofFile);
